module.exports = {
  // Mainnet
  '1': '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
  // Ropsten
  '3': '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
  // Rinkeby
  '4': '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e',
  // Goerli
  '5': '0x00000000000C2E074eC69A0dFb2997BA6C7d2e1e'
};